import { useRef } from "react";
import { useSelector } from "react-redux";
import { getWindowLock } from "../../../abstract/redux/slice/overlaySlice";
import { hasEmptyNode } from "../../../abstract/redux/slice/structureSlice";
import styles from './ButtonOverlay.module.scss';

export function ButtonOverlay({ handler, children }) {
  const ref = useRef(null);
  const isEmpty = useSelector(hasEmptyNode);
  const isLocked = useSelector(getWindowLock);

  const handleOnMouseDown = (e) => {
    
    if (e) {
      e?.preventDefault();
    }

    if (!isEmpty) {
      handler();
    } else if (!isLocked) {
      ref?.current?.focus();
    }
  };

  return (
    <button className={styles['empty']} ref={ref} onMouseDown={handleOnMouseDown}>
      {children}
    </button>
  );
}
